<template>
  <section id="thanks">
    <loading :active.sync="is_loading"></loading>
    <div class="ps" v-show="is_payed">
      <div class="ps-header">
        <div class="ps-reminder">Ficha digital. No es necesario imprimir.</div>
        <div class="ps-info">
          <img loading="lazy" :src="image" alt="" />
        </div>
        <div class="ps-reference">
          <h3>FELICIDADES</h3>
          <p>Se confirmó tu pago</p>
          <!-- <p>Tú pedido llegará en un periodo entre 10 a 20 días</p> -->
          <p>Tu pedido quedó registrado con el número de orden: {{ orden }}</p>
        </div>
      </div>
      <div class="ps-instructions">
        <div class="ps-footnote">
          Pronto recibirás un correo de <strong>MMK Group</strong> confirmando
          tu pago.
        </div>
      </div>
    </div>
    <div class="ps" v-show="is_error">
        <div class="ps-header">
            <div class="ps-reference">
                <h3>Hubo un error</h3>
                <p>{{ message }}</p>
            </div>
        </div>
    </div>
    <div class="ps" v-show="is_loading">
        <div class="ps-header">
            <div class="ps-reference">
                <h3>Procesando ...</h3>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
const axios = require("axios");

export default {
  name: "checkout",
  data() {
    return {
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      image: "",
      orden: "",
      is_loading: true,
      is_payed: false,
      is_error: false,
      message: '',
    };
  },
  components: {
    Loading,
  },
  mounted() {
    this.$store.commit('initialiseStore');
    console.info("Revisando URL: ", document.location.href.toString().split('#')[0]);
    const openpayParam = this.getParameterByName('id', document.location.href.toString().split('#')[0]);
    console.info("Parametro ID: ", openpayParam);
    console.info("Datos de los parametros: ", this.$route.query);
    if(this.$route.query.id){
      this.confirmOpenpayPayment();
    }else if(openpayParam){
      console.info("Hay parametro de openpay");
      this.confirmOpenpayPayment(openpayParam);
    }
  },
  methods: {
    getParameterByName: function(name, url){
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    confirmOpenpayPayment: function(openpayId = this.$route.query.id){
      axios({
        method: 'POST',
        url: this.api_url + '/payment/openpay-3dsecure-response',
        data: {
          id: openpayId
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("utoken"),
        },
      }).then((response) => {
        if(response.data.status){
            window.dataLayer.push({
              'event': 'productoComprado',
              'pageURL': this.$router.currentRoute.fullPath,
              'product': JSON.parse(localStorage.getItem('productWaiting')),
              'dateOfPurchase': new Date().toLocaleString('en-US')
            });
            console.info(localStorage.getItem('productWaiting'));
            console.log(this.$store.state.product);
            this.is_payed = true;
            this.$snotify.success(response.data.message);
            this.orden = response.data.payment.order;

            this.$store.commit("finishStore");
            this.$store.commit("finishProduct");
        }else{
            this.is_error = true;
            this.message = response.data.message;
            this.$snotify.warning(response.data.message);
        }
        this.is_loading = false;
      }).catch((error) => {
        this.is_loading = false;
        this.is_error = true;
        console.error(error);
        this.message = error;
      });
    },
  },
};
</script>
